module.exports = __webpack_public_path__ + "img/big.b6fb2151.jpg";